import { AuthDeviceDB } from '@/accessors/indexedDB/authDeviceDB'
import MiiaFwConfig from '@/configs/config'
import { useApiGw } from '@/modules/miiaFw/composables/useApiGw'
import type {
  ArgQueryInspectionResult,
  ArgUpsertItemInspectionResult,
  ResQueryInspectionResult,
  ResUpsertItemInspectionResult
} from '@/types/accessor/api/emergencyInspectionResult/emergencyInspectionResult'

const authDeviceDB = AuthDeviceDB.instance

/**
 * 調査実施結果APIのupsert（登録・更新）を実行する
 *
 * @param arg - upsert用リクエストパラメータ
 * @returns
 *   - needRecords: false または未指定の場合 → 登録完了メッセージ（ResUpsertItemInspectionResult）
 *   - needRecords: true の場合 → query APIと同じ調査結果一覧（ResQueryInspectionResult）
 *
 * @note
 *   - needRecordsフラグにより返却内容が変化する
 *   - trueの場合は「登録後の最新データ一覧」を返し、query APIのレスポンスと同じ型になる
 */
export const upsertEmergencyInspectionResultApi = async (
  arg: ArgUpsertItemInspectionResult
): Promise<ResUpsertItemInspectionResult | ResQueryInspectionResult> => {
  const { invokeApiGwFunc } = useApiGw()
  const deviceToken = await authDeviceDB.getDeviceToken()
  return await new Promise((resolve, reject) => {
    invokeApiGwFunc(
      // API Gatewayのエンドポイント
      MiiaFwConfig.config.apiGwEndpointEmergency,
      // Lambda関数をコールするためのWebAPIのサブディレクトリ
      '/emergencyInspectionResult',
      // Lambda関数に渡す引数
      {
        function: 'upsert',
        params: { ...arg, deviceToken: deviceToken }
      },
      // Lambda関数実行前の前処理のコールバック
      () => {},
      // 成功時のコールバック
      (res: { result: ResUpsertItemInspectionResult } | { result: ResQueryInspectionResult }) => {
        resolve(res.result)
      },
      // 例外受信時のコールバック(引数: エラーメッセージ)
      err => {
        reject(err)
      },
      // 予期せぬエラー(アクセス回線障害など)発生時のコールバック
      () => {
        reject({ message: 'API実行に失敗しました。(原因: アクセス回線障害など)' })
      },
      // 処理完了後に実行するコールバック
      () => {},
      // ローディングアイコンを表示しない
      false,
      true
    )
  })
}

export const queryEmergencyInspectionResultApi = async (
  arg: ArgQueryInspectionResult
): Promise<ResQueryInspectionResult> => {
  const { invokeApiGwFunc } = useApiGw()
  const deviceToken = await authDeviceDB.getDeviceToken()
  return await new Promise((resolve, reject) => {
    invokeApiGwFunc(
      // API Gatewayのエンドポイント
      MiiaFwConfig.config.apiGwEndpointEmergency,
      // Lambda関数をコールするためのWebAPIのサブディレクトリ
      '/emergencyInspectionResult',
      // Lambda関数に渡す引数
      {
        function: 'query',
        params: { ...arg, deviceToken: deviceToken }
      },
      // Lambda関数実行前の前処理のコールバック
      () => {},
      // 成功時のコールバック
      (res: { result: ResQueryInspectionResult }) => {
        resolve(res.result)
      },
      // 例外受信時のコールバック(引数: エラーメッセージ)
      err => {
        reject(err)
      },
      // 予期せぬエラー(アクセス回線障害など)発生時のコールバック
      () => {
        reject({ message: 'API実行に失敗しました。(原因: アクセス回線障害など)' })
      },
      // 処理完了後に実行するコールバック
      () => {},
      // ローディングアイコンを表示しない
      false,
      true
    )
  })
}
